<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">
    	<span [innerHTML]="album.name | safeHtml"></span>
    </h3>
</div>
<div class="modal-body">
    <div class="album-share form-signin" id="albumShareForm">
        <label for="albumInput">{{LOCALIZATION.albumShareWithUsers}}</label>
        <div class="input-group-btn row" style="width:100%;">
            <input id="albumInput" name="albumInput" [(ngModel)]="input.suggestUser" 
            	class="form-control flex-19" 
            	type="text"
            	[disabled]="input.isPublic"
            	(ngModelChange)="onSuggestTermChange($event)" 
                (keyup)="onUserSuggestKeyUp($event)"
                (selectItem)="addUserToSuggestion($event)"
                placeholder='Enter in an email/username' title='' />
        </div>        
        <label class="row" *ngIf="input.suggestions.length>0">{{LOCALIZATION.suggestions}}</label>
        <div *ngIf="input.suggestions.length>0" class="suggestion-container">
            <div (click)="addUserToSuggestion(suggestion)" class="suggestion pointMe"
                *ngFor="let suggestion of input.suggestions">
                {{((suggestion.firstName + ' ' + suggestion.lastName) || 'No Full Name Attached') + ' (' +
                suggestion.email + ')'}}
            </div>
        </div>
        <div class="row user-submission" *ngIf="!input.isPublic">
            <div *ngFor="let submission of input.usersToSubmit; let i = index;" [ngClass]="{'added': submission.add}" class="row item-hover pointMe">
                <div class="col-xs-1">
                    <button class="btn btn-default btn-sm" (click)="removeUserInSubmit(i)">
                        <i class="fa fa-times text-red"></i>
                    </button>
                </div>
                <div class="col-xs-11 album-share-item-text-container">
                    <span title="{{submission.displayName}}">{{submission.displayName}}</span>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="userPermissions['ROLE_PUBLISH_ALBUM']">
            <div class="col-md-12">
                <label for="albumpublic">{{LOCALIZATION.albumIsPublic}}</label>
                <div class="toggle-switch">
                    <input id="albumpublic" name="albumpublic"
                    	type="checkbox"
                    	class="toggle-switch-toggle toggle-switch-toggle-round" 
                        [(ngModel)]="input.isPublic">
                    <label for="albumpublic"></label>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
    <button (click)="shareAlbum()" style="margin-left:8px;" class="btn btn-default">
        <i class="fa fa-plus accent-color" style="padding-right: 4px;"></i>{{LOCALIZATION.share}}
    </button>
</div>
